import { createSelector } from 'reselect'

const getUserPermissions = state => state.user.permissions

const userPermissionsSelector = createSelector(
	[ getUserPermissions ],
	userPermissions => ({
		hasAccessToVideoLessonsFromStore: userPermissions.hasAccessToVideoLessonsFromStore,
		isLoaded: userPermissions._isLoaded,
	})
)

export default userPermissionsSelector
